function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Designs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stimson-UN-Handbook-Desktop-1",
  transform: "translate(-1389.000000, -20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profile/Unselected",
  transform: "translate(1360.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-person-24px",
  transform: "translate(29.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.824,10.824 C12.81742,10.824 14.432,9.20942 14.432,7.216 C14.432,5.22258 12.81742,3.608 10.824,3.608 C8.83058,3.608 7.216,5.22258 7.216,7.216 C7.216,9.20942 8.83058,10.824 10.824,10.824 Z M10.824,12.628 C8.41566,12.628 3.608,13.83668 3.608,16.236 L3.608,18.04 L18.04,18.04 L18.04,16.236 C18.04,13.83668 13.23234,12.628 10.824,12.628 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 21.648 0 21.648 21.648 0 21.648"
})))));

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ECD5E62A-4669-453D-96EC-DC792F6D1586") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1e753305.svg";
export { ForwardRef as ReactComponent };